import React from 'react';
import {connect} from 'react-redux';
import Grid from '@material-ui/core/Grid';
import {get, isEqual} from 'lodash';
import ScrollEvent from '@peoplenet/vi-common-util/src/Form/ScrollEvent';
import CircularProgress from '@material-ui/core/CircularProgress';
import RecordCounter from '../../components/RecordCounter';
import {
  loadDVRs,
  loadTotalDVRs,
  getReportURL,
  subscribeForUpdates,
  unsubscribeForUpdates,
  getCurrentSubscription,
  clear
} from '../DVRhealthActions';
import SubscriptionPanel from '../component/SubscriptionPanel';
import DVRCard from './DVRCard';
import DownloadHealthReport from '../component/DownloadHealthReport';
import {isMobile} from '../../app/configuration/util';

class DVRhealthPage extends React.Component {
  static defaultProps = {
    page: 0
  }
  

  componentDidMount() {
    this.props.loadDVRs(this.props.page, this.props.filters.applied);
    this.props.loadTotalDVRs(this.props.filters.applied);
  }

  componentWillReceiveProps(newProps) {
    if (!isEqual(newProps.filters.applied, this.props.filters.applied)) {
      this.props.clear();
      this.props.loadDVRs(0, newProps.filters.applied);
      this.props.loadTotalDVRs(newProps.filters.applied);
    }
  }

  componentDidUpdate = () => {
    const height = window.innerHeight;
    const innerH = document.body.clientHeight;
    if (height > innerH &&
      !this.props.loading &&
      this.props.dvrs.length > 0 &&
      (this.props.page + 1 < this.props.pages)) {
      this.props.loadDVRs(this.props.page + 1, this.props.filters.applied);
    }
  }

  componentWillUnmount() {
    this.props.clear();
  }

  handleDownloadReport = () => {
    const pairingMethod = get(this.props, 'customer.data.dvrPairing.method', 'dsn');
    const params = {
      pairingMethod,
      ...this.props.filters.applied
    };
    this.props.getReportURL(params);
  }

  handleLazyLoading = () => {
    if (!this.props.loading && this.props.pages > (this.props.page + 1)) {
      const h = document.documentElement;
      const b = document.body;
      const st = 'scrollTop';
      const sh = 'scrollHeight';
      const percent = ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
      if (percent > 80) {
        this.props.loadDVRs(this.props.page + 1, this.props.filters.applied);
      }
    }
  }

  handleLazyLoadingGeotab = () => {
    if (!this.props.loading && this.props.pages > (this.props.page + 1)) {
      const h = document.getElementById('root').parentElement;
      const b = document.getElementById('root');
      const st = 'scrollTop';
      const sh = 'scrollHeight';
      const percent = ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
      if (percent > 80) {
        this.props.loadDVRs(this.props.page + 1, this.props.filters.applied);
      }
    }
  }

  render() {
    const {cardView} = this.props.filters.applied;
    const system = localStorage.getItem('systemId');
    return (
      <div>
        {/* TODO: add filters */}
        <Grid container className="dvrcard__uiactions-subscription">
          <Grid item lg={3} md={4} sm={6} xs={12} className="dvrcard__subscription">
            <SubscriptionPanel
              userEmail={this.props.userInformation.email}
              healthSubscription={this.props.healthSubscription}
              subscribeForUpdates={this.props.subscribeForUpdates}
              unsubscribeForUpdates={this.props.unsubscribeForUpdates}
              getCurrentSubscription={this.props.getCurrentSubscription}
            />
          </Grid>
          <Grid item lg={8} md={7} sm={6} xs={12} className="dvrcard__download">
            {this.props.dvrs.length > 0 && !this.props.isMobile &&
              <DownloadHealthReport handleClick={this.handleDownloadReport} reportFile={this.props.reportFile} />
            }
            <div className={this.props.isMobile ? 'dvrcard__subscription dvrcard__counter-margin' : 'dvrcard__download'}>
              <RecordCounter records={this.props.totalDvrs} />
            </div>
          </Grid>
        </Grid>
        {system === 'geotab' &&
          <ScrollEvent handleScrollCallback={this.handleLazyLoadingGeotab} />
        }
        {system != 'geotab' && 
          <ScrollEvent handleScrollCallback={this.handleLazyLoading} />
        }
        <Grid container spacing={16}>
          {this.props.dvrs.map((dvr, index) =>
            (<DVRCard
              id={`dvrCard${index}`}
              type={cardView}
              key={dvr.serialNo}
              {...dvr}
            />))}
          {this.props.loading &&
            <div className="dvrcard__progresscont">
              <CircularProgress className="loading__cirgularprogress" size={50} />
            </div>
          }
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const system = localStorage.getItem('systemId');
  let userInformation = '';
  if(system === 'geotab'){
    userInformation = get(state, 'security.userInfo');
  }else{
    userInformation = get(state, 'user.userInformation');
  }

  return {
    ...state.dvr,
    customer: state.customer,
    userInformation,
    filters: {
      ...state.dvrFilter
    },
    isMobile: isMobile(state)
  };
};

export default connect(mapStateToProps, {
  loadDVRs,
  loadTotalDVRs,
  getReportURL,
  subscribeForUpdates,
  unsubscribeForUpdates,
  getCurrentSubscription,
  clear
})(DVRhealthPage);
